import AdministationService from '@/services/AdministationService';
import axios from 'axios';
import DashboardService from '@/services/DashboardService-bmw'
import { DxCommonSeriesSettingsHoverStyle } from 'devextreme-vue/chart';

export default {
  props: {

  },

  data() {
    return {
      activeClientId: null,

      autoFilter : {
        isEnabled: false
      },

      filterRank: [
        'Surveys',
        'Waves',
        'Regions',
        'Subregions',
        'NSCs',
        'SubNSCs',
        'Areas',
        'Dealergroups',
        'ClientLocations'
      ],

      last: {
        Brand: [],
        Surveys : [],
        Waves : [],
        Regions : [],
        Subregions : [],
        NSCs : [],
        SubNSCs : [],
        Areas : [],
        Dealergroups : [],
        ClientLocations : [],
        WebsiteAnswers : null
      },

      brandsFlat: [],

      selection: {
        Brand: [],
        Surveys : [],
        Waves : [],
        Regions : [],
        Subregions : [],
        NSCs : [],
        SubNSCs : [],
        Areas : [],
        Dealergroups : [],
        ClientLocations : [],
        WebsiteAnswers : null
      },

      optionState: {
        Brand: false,
        Surveys : false,
        Waves : false,
        Regions : false,
        Subregions : false,
        NSCs : false,
        SubNSCs : false,
        Areas : false,
        Dealergroups : false,
        ClientLocations : false,
        WebsiteAnswers : false
      },

      currentFilter: null,
      isLoading: false,
      isOutdated: false,

      isBmwMoto: false,
      isBmwM: false,
      isBmwi: false,
      isGebrauchtwagen: false,
      isUsedCar: false,
      isUsedCar2021: false,
      isUsedBike: false,
      isBmw2020: false,
      isBmw2021: this.$router ? !this.$router.currentRoute.path.endsWith('/cockpit2020') : true,
      yearSwitch : {
        isBmw2021 : false
      },

      cockpitCancelToken: null,
      optionsCancelToken: null,
      options2CancelToken: null,

      dashdata: [],
      optionsdata: {
        Brand: [],
        Surveys : [],
        Waves : [],
        Regions : [],
        Subregions : [],
        NSCs : [],
        SubNSCs : [],
        Areas : [],
        Dealergroups : [],
        ClientLocations : [],
        WebsiteAnswers : []
      },
      settingOptions: false,
      brandLock: false,
      itemsLock: false,
      thresholdConfig: [],

      years: [],
      yearsbywave: [],

      bmwMotorradSelectedSurveyId: undefined,

      toolTipDelay: { delay: { "show": 500, "hide": 100 } }
    }
  },

  methods: {
    initSingularItem(option, selection) {
      if (option.length === 1 &&
          selection.length === 0 &&
          option[0].ClientLocationCount === option[0].TotalClientLocationCount) {
        selection.push(option[0].id);
      }
    },

    ensureOptionsAreSetWhenSingleOptionExists(opt, sel) {
      this.initSingularItem(opt.Regions, sel.Regions);
      this.initSingularItem(opt.Subregions, sel.Subregions);
      this.initSingularItem(opt.NSCs, sel.NSCs);
      this.initSingularItem(opt.SubNSCs, sel.SubNSCs);
      this.initSingularItem(opt.Areas, sel.Areas);
      this.initSingularItem(opt.Dealergroups, sel.Dealergroups);
      this.initSingularItem(opt.ClientLocations, sel.ClientLocations);
    },

    selectFirstBrandIfEmpty() {
      // select a brand
      if (_.isEmpty(this.selection.Brand)) {
        this.selection.Brand.push(_.first(this.brandsFlat).id);
      }
    },

    selectMultipleBrandsIfEmpty() {
      let _this = this;
      // select a brand
      if (_.isEmpty(this.selection.Brand)) {
        if (this.isBmw2021) {
          // Select all BMW-Brands at startup
          _.filter(_this.brandsFlat, function(b) {
            if (b.type == 'Brand') {
              _this.selection.Brand.push(b.id);
            }
          });
        } else {
          this.selection.Brand.push(_.first(this.brandsFlat).id);
        }
      }
    },

    selectBrands(selection, opt) {
      if (selection.Brand.length !== 0 || opt.Brand.length === 0)
        return;

        if(opt.Brand[0].children) {
          if(opt.Brand[0].children[0].children) {
            selection.Brand = opt.Brand[0].children[0].children.map(x => x.id);
          } else {
            selection.Brand = opt.Brand[0].children.map(x => x.id);
          }
        } else {
          selection.Brand = [opt.Brand[0].id];    
        }

    },

    selectSurveys(selection, opt) {
      let contextYear = Math.max(...opt.Surveys.map(survey => survey.year));
      
      // Wenn keine Survey selektiert
      if (this.autoFilter.isEnabled && selection.Surveys.length === 0) {
        // Default: Alle 2019er Wellen selektieren
        // special logic - If "BMW Used Bike" is selected only one survey is allowed
        if (!this.getIsUsedBike(selection.Brand))
        {
          opt.Surveys.forEach(survey => {
            if (contextYear === 2019) {
              if (survey.year === 2019) {
                selection.Surveys.push(survey.id);
              }
            } else if (contextYear === 2020) {
              if (survey.year === 2020) {
                selection.Surveys.push(survey.id);
              }
            }
          });
        };

        // Wenn es keine 2019er Surveys gibt, dann die alte Variante (erster in der Liste)
        if (selection.Surveys.length === 0) {
          _.filter(opt.Surveys, function(s) {
            if(s.year >= 2021) {
              selection.Surveys.push(s.id);
            }
          });
        }
      } else {
        // autoFilter is disabled
        if (selection.Surveys.length === 0 && opt.Surveys.length > 0) {
          if (opt.Surveys.length === 1 && opt.Surveys[0].children) {
            selection.Surveys = opt.Surveys[0].children.map(x => x.id);
          } else  {
            selection.Surveys = opt.Surveys.map(x => x.id);
          }
        }
      }
    },

    invokeDashboardApi(args) {
      this.getDashboard(this);
    },

    // Wenn der Autofilter aus war und Änderungen an den Filtern vorhanden sind die noch nicht im Dashboard zu sehen sind,
    // dann beim Autofilter-Einschalten das Dashboard abrufen
    autoFilterSwitchChanged(args) {
      if (this.isOutdated && this.autoFilter.isEnabled && !this.isLoading) {
        this.getDashboard(this);
      }
    },

    getLocationActiveText() {
      return this.$t('Webportal.Location') + ' ' + this.$t('Webportal.Active');
    },

    getLocationInactiveText() {
      return this.$t('Webportal.Location') + ' ' + this.$t('Webportal.Inactive');
    },

    closeInfoDialog() {
      this.$refs.modalTooMuchWaves.hide();
    },

    resetSelection(items) {
      items.Surveys = [] // Selected structure items
      items.Waves = []
      items.Regions = []
      items.Subregions = []
      items.NSCs = []
      items.SubNSCs = []
      items.Areas = []
      items.Dealergroups = []
      items.ClientLocations = []
      items.WebsiteAnswers = null
    },

    handleInput(value, instanceId) {
      if (this.isLoading || this.brandLock || this.itemsLock) {
        return;
      }

      switch (instanceId) {
        case 'Brand':
          this.brandLock = true;
          if (_.size(value) === 0) {
            this.selection.Brand = null // Selected structure items
            this.resetSelection(this.selection);
          }
          if(this.last.Brand !== this.selection.Brand) {
            this.resetSelection(this.selection);
          }
          this.last.Brand = this.selection.Brand
          this.loadData(value, instanceId)
          this.brandLock = false;
          break;
        case 'WebsiteAnswers':
          if (!value || value.length === 0) this.optionState.WebsiteAnswers = true;
          if (!this.optionState.WebsiteAnswers) return;
          this.loadData(value, instanceId);
          break;

        default:
          // special logic - If "BMW Motorrad" is selected only on survey is allowed
          // the solution to set dynamically the multiple to false is not good,
          // because the selection is no array anymore then
          if (this.bmwMotorradSelectedSurveyId != undefined) {
            this.selection.Surveys = [this.bmwMotorradSelectedSurveyId];
            this.bmwMotorradSelectedSurveyId = undefined;
          }
          let obj = _.get(this.optionState, instanceId, undefined);
          if (obj === undefined) return;
          if (!value || value.length === 0) _.set(this.optionState, instanceId, true);
          if (obj === undefined) return;
          if (_.size(value) === 0) this.loadData(value, instanceId);
          break;
      }
    },

    handleClose(value, instanceId) {
      switch (instanceId) {
        case 'Brand':
          if (!this.optionState.Brand) return;
          // Do smt
          this.optionState.Brand = false;
          break;

        case 'WebsiteAnswers':
          break;

        case 'Waves':
          if (this.selection.Waves.length > 6) {
            this.selection.Waves = this.selection.Waves.slice(0, 6);
            this.$refs.modalTooMuchWaves.show();
          }
          this.handleCloseGeneric(value, instanceId);

        default:
          this.handleCloseGeneric(value, instanceId);
          break;
      }
    },

    handleCloseGeneric(value, instanceId) {
      let obj = _.get(this.optionState, instanceId, undefined);
      if (!obj) return;
      this.loadData(value, instanceId)
      _.set(this.optionState, instanceId, false);
    },

    handleSelect(node, instanceId) {

      // common handleSelect logic
      let obj = _.get(this.optionState, instanceId, undefined);
      if (obj === undefined) return;
      _.set(this.optionState, instanceId, true);

      // special logic - If "BMW Motorrad" or "BMW Used Bike" is selected only one survey is allowed
      // the solution to set dynamically the multiple to false is not good,
      // because the selection is no array anymore then
      if (
           this.selection
        && this.selection.Brand
        && this.selection.Brand.length > 0
        && (this.getIsBmwMoto(this.selection.Brand[0]) || this.getIsUsedBike(this.selection.Brand[0]))
        && instanceId === 'Surveys'
        && this.selection.Surveys
        && this.selection.Surveys.length > 0
        && node) {
          this.bmwMotorradSelectedSurveyId = node.id;
        }
    },

    handleDeselect(node, instanceId) {
      let obj = _.get(this.optionState, instanceId, undefined);
      if (obj === undefined) return;
      _.set(this.optionState, instanceId, true);
    },

    // Applies changed filter and triggeres data loading if necessary
    loadData(value, id) {
      let fltr = this.filterProperty(this);
      if (!_.isEqual(fltr, this.currentFilter)) {
        // iterate over all items in 'filterRank' starting with index + 1 of
        // actually changed item and set them to empty []
        // and skip first two items (Surveys and Waves)
        // prevent reload during operation with a bool lock
        this.itemsLock = true;
        if (_.indexOf(this.filterRank, id) > 1) {
          for (var i = _.indexOf(this.filterRank, id) + 1; i < this.filterRank.length; i++) {
            _.set(this.selection, this.filterRank[i], []);
          }
        }
        this.itemsLock = false;

        this.currentFilter = this.filterProperty(this);
        this.getOptions(id);
      }
    },

    trimItemNames(list) {
      if (list) {
        list.forEach(item => {
          item.KpiCode = item.KpiCode.replace(/\s*$/,"");
        });
      }
	  },

    setIsLoading(state) {
      this.isLoading = state;
      if  (this.thresholdSetting && this.thresholdSetting.options && this.thresholdSetting.options.length > 0) {
        for (const opt of this.thresholdSetting.options) {
          opt.disabled = state;
        }
      }
    },

    // Nötig, da KPI-Codes manchmal mit folgenden Leerzeichen eingepflegt werden.
    trimKpiNames(rawData) {
      if (rawData) {
        // Alle trailing whitespaces in KPI's trimmen
        this.trimItemNames(rawData.KPI);
        // Alle trailing whitespaces in KPI-Group's trimmen
        this.trimItemNames(rawData.KPIGroup);
      }
      return rawData;
    },

    filterSurveys(_this, opt) {
      if (!_this || !opt || !_this.selection || !_this.selection.Brand)
        return;

      let selectedBrands = this.getRealBrands(_this.selection.Brand);
      let type = this.getBrandGroup(_this.selection.Brand);

      _.remove(opt.Surveys.length === 1 && opt.Surveys[0].id === -1
        ? opt.Surveys[0].children : opt.Surveys
        , function(survey) {
          if (!Array.isArray(survey.BrandId)) console.error('should be an array');
          switch (type) {
            case 'n':
              // console.warn(`survey.id ${survey.id} >= -48 ${survey.id >= -48}`);
              return !(survey.id > -48 || survey.id == -53 || survey.id == -54) || !selectedBrands.some(r=> survey.BrandId.includes(r));

            case 'u':
              return !(survey.id <= -48 && survey.id != -53 && survey.id != -54) || !selectedBrands.some(r=> survey.BrandId.includes(r));

            default:
              return !selectedBrands.some(r=> survey.BrandId.includes(r));
          }
        });
    },

    getBrandGroup(selectedBrands) {
      if (selectedBrands[0].startsWith('n')) {
        return 'n';
      } else if (selectedBrands[0].startsWith('u')) {
        return 'u';
      } else {
        return undefined;
      }
    },

    getRealBrands(selectedBrands) {
      let theBrands = _.split(_.join(selectedBrands, '|'), '|');
      return _.map(theBrands,
        x => x.startsWith('n') || x.startsWith('u') ? x.substring(1) : x);
    },

    filterProperty(_this) {
      let contact = null;
      if (!_.isEmpty(_this.selection.WebsiteAnswers)) {
        contact = _this.selection.WebsiteAnswers; }

        if (_this.selection.Surveys.length !== 0 && _this.selection.Waves.length === 0)
          _this.selection.Waves = _this.optionsdata.Waves ? _this.optionsdata.Waves.slice(-4).map(x => x.id) : [];

      let result = {
        brand:              _.join(this.getRealBrands(_this.selection.Brand), '|'),
        surveys:            _.join(_this.selection.Surveys, ','),
        waves:              _.join(_this.selection.Waves, ','),
        regions:            _.join(_this.selection.Regions, '|'),
        subregions:         _.join(_this.selection.Subregions, '|'),
        nscs:               _.join(_this.selection.NSCs, '|'),
        nscsub:             _.join(_this.selection.SubNSCs, '|'),
        areas:              _.join(_this.selection.Areas, '|'),
        dealergroups:       _.join(_this.selection.Dealergroups, '|'),
        outlets:            _.join(_this.selection.ClientLocations, ','),
        contactinitiation:  contact
      };
      return this.applyApiLayerToFilterProperty(result);
    },

    getOptions(sender) {
      var _this = this;
      var isBrandChange = this.brandLock;

      _this.isBmwMoto = false;
      _this.isUsedBike = false;
      _this.isBmwM = false;
      _this.isBmwi = false;
      _this.isGebrauchtwagen = false;
      _this.isUsedCar = false;
      _this.isBmw2020 = false;

      _this.isLoading = true;

      if (sender !== 'mounted' && !isBrandChange) {
         // Cancel previous request
        if (_this.optionsCancelToken) _this.optionsCancelToken.cancel();
        _this.optionsCancelToken = axios.CancelToken.source();

        DashboardService.getOptions(_this.currentFilter).then(response => {
          _this.tryFetchClientSettings(_.findLast(response.data, (x) => x));
          _this.setOptions(_this, sender, _.findLast(response.data, (x) => x));
          _this.currentFilter = _this.filterProperty(_this);

          // Wenn autofilter aus und ohne args aus ButtonClick aufgerufen wurde, dann abbrechen
          if (_this.autoFilter.isEnabled === true) {
            _this.getDashboard(_this);
          } else {
            _this.isLoading = false;
            _this.isOutdated = true;
          }
        });

        return;
      } else {
        // Cancel previous request
        if (_this.optionsCancelToken) _this.optionsCancelToken.cancel();
        _this.optionsCancelToken = axios.CancelToken.source();

        DashboardService.getOptions(_this.applyApiLayerToFilterProperty(_this.currentFilter)).then(response => {
          _this.tryFetchClientSettings(_.findLast(response.data, (x) => x));
          _this.setOptions(_this, sender, _.findLast(response.data, (x) => x));
          if (sender === 'mounted' || isBrandChange) {

            if (_this.options2CancelToken) _this.options2CancelToken.cancel();
            _this.options2CancelToken = axios.CancelToken.source();
            _this.currentFilter = _this.filterProperty(_this);

            DashboardService.getOptions(_this.currentFilter).then(response => {
              _this.tryFetchClientSettings(_.findLast(response.data, (x) => x));
              _this.setOptions(_this, sender, _.findLast(response.data, (x) => x));
              _this.currentFilter = _this.filterProperty(_this);

              // Beim mount auch bei abgeschaltetem AutoFilter einmal das Dashboard laden
              // Wenn autofilter aus und ohne args aus ButtonClick aufgerufen wurde, dann abbrechen
              if (_this.autoFilter.isEnabled === true && sender === 'mounted') {
                _this.getDashboard(_this);
              } else {
                // var brandId = _.head(_this.selection.Brand);
                // var brnd = _.find(_this.optionsdata.Brand, ['id', brandId]);
                // if (brnd && brnd.group > 1) {
                //   _this.getDashboard(_this);
                // } else {
                  _this.isLoading = false;
                  _this.isOutdated = true;
                // }
              }
            });
          }
        });
      }
    },

    tryFetchClientSettings(opt) {
      if (!opt || !opt._visuals || !opt._visuals.length === 1) return;

      let client = this.isBmwMoto 
        ? opt._visuals[0].ClientBmwMotorrad
        : opt._visuals[0].ClientBmw;

      if (this.activeClientId === client) return;
      this.activeClientId = client;

      this.getClientSettings(client);
    },

    getClientSettings(clientId) {
      AdministationService.getClientSettings(clientId).then(response => {
        if (response.data && response.data[0]) {
          this.thresholdConfig = response.data[0].Thresholds;
        }
      });
    },

    setOutlets(opt) {
      if (!opt || !opt.ClientLocations || opt.ClientLocations.length <= 0) return;
      let results = [];
      for (const loc of opt.ClientLocations) {
        let item = _.find(results, ['OnSiteId', loc.OnSiteId]);
        if(!item) {
          results.push(loc);
        } else {
          item.id += `,${loc.id}`;
          if (!item.lat && loc.lat)
            item.lat = loc.lat;
          if (!item.lng && loc.lng)
            item.lng = loc.lng;
        }
      }

      opt.ClientLocations = results;
    },

    setCustomProperties(collection) {
      if (!collection || collection.length <= 0) return;
      let results = [];
      for (const reg of collection) {
        let item = _.find(results, ['label', reg.label]);
        if(!item) {
          results.push({ id: reg.id, label: reg.label });
        } else {
          item.id += `§${reg.id}`;
        }
      }
      return results;
    }

  },

  computed: {
    thresholds: function() {
      // Fallbacks
      if (!this.isBmwMoto) {
        if (_.isEmpty(this.selection.Areas) && _.isEmpty(this.selection.Areas) && _.isEmpty(this.selection.Areas)) {
          return [
            { Minimum: 0.00, Maximum: 89.99, Color: "#eb331e", Smiley: "frown-open" },
            { Minimum: 90.00, Maximum: 94.99, Color: "#ffe20a", Smiley: "meh" },
            { Minimum: 95.00, Maximum: 100.00, Color: "#42cf76", Smiley: "grin" }
          ];
        }
        return [
          { Minimum: 0.00, Maximum: 79.99, Color: "#eb331e", Smiley: "frown-open" },
          { Minimum: 80.00, Maximum: 89.99, Color: "#ffe20a", Smiley: "meh" },
          { Minimum: 90.00, Maximum: 100.00, Color: "#42cf76", Smiley: "grin" }
        ];
      } else {
        return [
          { Minimum: 0.00, Maximum: 59.99, Color: "#eb331e", Smiley: "frown-open" },
          { Minimum: 60.00, Maximum: 79.99, Color: "#ffe20a", Smiley: "meh" },
          { Minimum: 80.00, Maximum: 100.00, Color: "#42cf76", Smiley: "grin" }
        ];
      }
    },

    showPlaceholder: function() {
      if (this.isGebrauchtwagen) {
        return !this.dashdata || !this.selection.Brand || !this.selection.Surveys || !this.dashdata.Question;
      }
      return !this.isOutdated && (!this.dashdata || !this.selection.Brand || !this.selection.Surveys || !this.dashdata.KPI);
    },

    hasOptions: function() {
      return !_.isEmpty(this.selection.Brand)
          && !_.isEmpty(this.selection.Surveys)
          && !_.isEmpty(this.optionsdata);
    },

    isRefreshDisabled() {
      return this.autoFilter.isEnabled || this.isLoading || this.selection.Brand.length === 0 || this.selection.Surveys.length === 0
    },

    isWaveFilterEnabled: function() {
      return this.hasOptions && this.optionsdata.Waves && this.optionsdata.Waves.length > 0;
    },

    isRegionFilterEnabled: function() {
      return this.hasOptions && this.optionsdata.Regions && this.optionsdata.Regions.length > 0;
    },

    isSubregionFilterEnabled : function() {
      return this.hasOptions && this.optionsdata.Subregions && this.optionsdata.Subregions.length > 0;
    },

    isNscFilterEnabled: function() {
      return this.hasOptions && this.optionsdata.NSCs && this.optionsdata.NSCs.length > 0;
    },

    isNscSubFilterEnabled: function() {
      return this.hasOptions && this.optionsdata.SubNSCs && this.optionsdata.SubNSCs.length > 0;
    },

    isAreaFilterEnabled: function() {
      return this.hasOptions && this.optionsdata.Areas && this.optionsdata.Areas.length > 0;
    },

    isDealergroupFilterEnabled: function() {
      return this.hasOptions && this.optionsdata.Dealergroups && this.optionsdata.Dealergroups.length > 0;
    },

    isOutletsFilterEnabled: function() {
      return this.hasOptions && this.optionsdata.ClientLocations && this.optionsdata.ClientLocations.length > 0;
    },

    isWebsiteAnswersEnabled: function() {
      return !_.isEmpty(this.selection.Brand) || !this.isBmwMoto || !this.isUsedBike || !this.isLoading || this.optionsdata.WebsiteAnswers.length > 0;
    }

  }
};
